import { Component, OnInit } from '@angular/core';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { animate, style, transition, trigger } from '@angular/animations';
import { AutenticacaoService } from '../../services/autenticacao.service';
import { Mensagem } from 'shared/entities/mensagem.entity';
import { LoginOperador } from 'shared/entities/loginoperador.entity';
import { UsuarioConta } from 'shared/entities/usuarioconta.entity';
import { TrocaSenha } from 'shared/entities/trocasenha.entity';
import { AlertifyService } from 'shared/services/alertify.service';
import { UsuarioAutenticado } from 'shared/entities/usuarioautenticado.entity';
import { NavegacaoPaginaService } from '../../services/navegacaopagina.service';


@Component({
  selector: 'aceitacao-acesso',
  templateUrl: './aceitacao-acesso.component.html',
  styleUrls: ['./aceitacao-acesso.component.scss'],
  animations: [
    trigger('openClosed', [
      transition(':enter', [
        style({ transform: 'translateX(-100%)' }),
        animate('0.3s', style({ transform: 'translateX(0)' }))
      ]),
      transition(':leave', [
        animate('0.1s', style({ transform: 'translateX(-100%)' }))
      ])
    ])
  ]
})

export class AceitacaoAcessoComponent implements OnInit {

  public Erros: Mensagem[] = []; 
  public DadoAutenticacao: UsuarioAutenticado = new UsuarioAutenticado();
  public Aceitacao: boolean=false;

  constructor(

    readonly router: Router,
    readonly autenticacaoSrv: AutenticacaoService,
    readonly alertify: AlertifyService,
    public readonly srvNavegacao: NavegacaoPaginaService
  ) {
    

  }

  ngOnInit() {

  }

  Confirmar(): void {
    this.Erros = [];
    this.autenticacaoSrv.ConfirmarTermoIB().subscribe(resultado => {

      
        this.autenticacaoSrv.DadoAutenticacao.IBConfirmacao = true;
        this.router.navigate(['home']);
      
      
    });
  }

  Cancelar():void{
   
    this.autenticacaoSrv.LogOut().subscribe(d=>
      {
        this.srvNavegacao.ConfirmarInternetBanking(false);
        this.srvNavegacao.AlterarSenha(false);
      });
  }



}
